import { CheckboxProps } from '@mui/material';
import { MouseEvent } from 'react';

import { StyledCheckbox } from './Checkbox.style';

type Props = { onClick?: (event: MouseEvent<unknown>) => void } & CheckboxProps;
export const Checkbox = ({ onClick, ...props }: Props) => {
  return <StyledCheckbox onClick={onClick} {...props} color="primary" />;
};
